import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_2 = { class: "py-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentDownloadIcon = _resolveComponent("DocumentDownloadIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createBlock(_component_Menu, {
    as: "div",
    class: "relative inline-block text-right z-10 save-export"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_MenuButton, { class: "inline-flex justify-center px-4 py-2 mx-2 bg-white hover:bg-gray-50 focus:outline-none" }, {
          default: _withCtx(() => [
            _createVNode(_component_DocumentDownloadIcon, { class: "h-4 w-4" }),
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "opacity-0 scale-95",
        "enter-to-class": "opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "opacity-100 scale-100",
        "leave-to-class": "opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MenuItems, { class: "origin-top-right absolute right-0 mt-2 w-max rounded-md shadow-lg bg-white ring-1 ring-black/5 divide-y divide-gray-100 focus:outline-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.user.enabled && _ctx.user.isSignedIn)
                  ? (_openBlock(), _createBlock(_component_MenuItem, { key: 0 }, {
                      default: _withCtx(({ active }) => [
                        _createElementVNode("button", {
                          class: _normalizeClass([
            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
            'group flex items-center px-4 py-2 text-sm text-right'
          ]),
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveToFavorites && _ctx.saveToFavorites(...args)))
                        }, " Save to Favorites ", 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_MenuItem, null, {
                  default: _withCtx(({ active }) => [
                    _createElementVNode("button", {
                      href: "#",
                      class: _normalizeClass([
            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
            'group flex items-center px-4 py-2 text-sm w-full text-right'
          ]),
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadBibFile && _ctx.downloadBibFile(...args)))
                    }, " BibTex ", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_MenuItem, null, {
                  default: _withCtx(({ active }) => [
                    _createElementVNode("button", {
                      href: "#",
                      class: _normalizeClass([
            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
            'group flex items-center px-4 py-2 text-sm w-full text-right'
          ]),
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadRisFile && _ctx.downloadRisFile(...args)))
                    }, " RIS ", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_MenuItem, null, {
                  default: _withCtx(({ active }) => [
                    _createElementVNode("button", {
                      href: "#",
                      class: _normalizeClass([
            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
            'group flex items-center px-4 py-2 text-sm w-full text-right'
          ]),
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportToMendeley && _ctx.exportToMendeley(...args)))
                    }, " Mendeley ", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_MenuItem, null, {
                  default: _withCtx(({ active }) => [
                    _createElementVNode("button", {
                      href: "#",
                      class: _normalizeClass([
            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
            'group flex items-center px-4 py-2 text-sm w-full text-right'
          ]),
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportToZotero && _ctx.exportToZotero(...args)))
                    }, " Zotero ", 2)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}